import { get } from "lodash";
import moment from "moment";

const deserializeUniversityDetails = (universityDetails) => {
	const lodashGet = (key, defaultValue) =>
		get(universityDetails, key, defaultValue);
	const getEventDate = (date) => moment(date).format("DD MMMM YYYY");
	let data = {},
		eventType = lodashGet("university.Event_Type");
	if (universityDetails) {
		data = {
			universityCode: lodashGet("university_code", ""),
			fairID: lodashGet("fair_id", ""),
			universityName: lodashGet("university.Account_Name", ""),
			eventDate: getEventDate(lodashGet("university.Event_Date", "")),
			isOnlineEvent: eventType ? !eventType.toLowerCase().includes("offline") : false,
			showPU: lodashGet("university.Is_PU_access_allowed", false),
		};
	}
	return data;
};

export { deserializeUniversityDetails };
